export enum AppRoutes {
  HOME = '/',
  LANDING_PAGE = '/landingpage',
  GUIDE = '/guide/results',
  SUMMARY = '/summary',
  SUMMARY_VPC = '/summary/vpc/:vpcCode',
  PLANNER = '/planner',
  VPC = '/vpc/:vpcCode',
  SPR = '/spr/:sprId',
  DESIGN_ID = '/designId/:designId',
  PLANNER_NEW = '/planner/new',
  PLANNER_SCREENSAVER = '/planner/screensaver',
  IKEA_HOME = 'https://www.ikea.com/',
  CRASH = '/crash'
}
